import { Box, Card, Link, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"

const NotFound = () => {
  const navigate = useNavigate()
  return (
    <Box display="flex-col" justifyContent="center" mt={5}>
      <Box display="flex" justifyContent="center">
        <Typography variant="h2">Not Found</Typography>
      </Box>
      <Box display="flex" justifyContent="center" mt={3}>
        <Card sx={{ padding: 5 }}>
          <Box display="flex-col" justifyContent="center" mt={3}>
            <Typography color="red">お探しのページは見つかりませんでした。</Typography>
            <Box display="flex" justifyContent="center" mt={3}>
              <Link onClick={() => navigate('/')}>TOP画面へ</Link>
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  )
}
export default NotFound
